import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app/app.reducer';

@Injectable()
export class ClienteSelectRedux {

  constructor(private store: Store<AppState>) {
  }

   buscarClienteSelectStore() {
    return new Promise((resolve, reject) => {
       this.store.select(store => store.clienteSelectAll).subscribe((clienteSelect) => {
         return resolve(clienteSelect)
       })
     });
   }
}



// WEBPACK FOOTER //
// ./src/providers/redux/clienteselect/clienteselect.ts